module.exports = __webpack_public_path__ + "img/1576419639.562f548d.jpg";